// extracted by mini-css-extract-plugin
export default {"wrapper":"EditDesignTemplateItem_wrapper__b-Mj3","active":"EditDesignTemplateItem_active__t5ZD8","inner":"EditDesignTemplateItem_inner__TwsK-"};